import React from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "../interact/Button";

/**
 * LoadError
 * ---------
 * Shown in place of data that failed to load, so a failed request never reads as real figures
 * (a 500 on the overview used to render "0" revenue). Pair it with useFetch's `error` + `refetch`.
 */

interface LoadErrorProps {
  /** What failed to load, in the sentence "We couldn't load {what}." */
  what: string;
  onRetry?: () => void;
  className?: string;
}

export const LoadError: React.FC<LoadErrorProps> = ({ what, onRetry, className }) => {
  return (
    <div
      role="alert"
      className={`flex items-center justify-between gap-4 rounded-xl border border-dangerMedium bg-dangerLight px-6 py-4 text-sm text-danger ${className ?? ""}`}
    >
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
        <span>We couldn't load {what}. Please try again in a moment.</span>
      </div>
      {onRetry && (
        <Button variant="tertiary" size="small" onClick={onRetry}>
          Try again
        </Button>
      )}
    </div>
  );
};
